define('Components/Jobs/js/Jobs',['hooks','Components/Jobs/js/views/JobsPageView'],
    function(hooks,JobsPageView){

    return function(){
        hooks.registerHook('PageFactory', function (pageName, callback) {
            switch (pageName) {
                case 'JobsController' :
                    console.log(pageName);
                    callback.call(null, JobsPageView);
                    break;
            }
        });
    }

});
